import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function SoefragtUSACanada() {
  return (
    <>
      <SEO
        title="Omhyggelig søfragt til og fra USA og Canada | Fastlane ApS"
        description="Søfragt arrangeres via udvalgte rederier som stykgods - LCL eller i hele containere - FCL til og fra USA og Canada. De største havnebyer på øst- og vestkysten."
        canonicalUrl="https://fastlane.dk/soefragt-usa-canada"
      />

      <PageHeader
        title="Søfragt / Containerfragt USA og Canada"
        subtitle="Omhyggelig søfragt i hele containere (FCL) eller som stykgods (LCL) til og fra USA og Canada."
        breadcrumbs={[
          { label: 'Ydelser', path: '/containerfragt-soefragt' },
          { label: 'USA og Canada' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <div className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <p>
              LCL (Less than Container Load eller på dansk stykgods) og FCL (Full Container Load) til / fra USA og Canada arrangeres via nøje udvalgte samarbejdspartnere.
            </p>
            <p>
              Søfragtsraterne kan svinge en del over tid. Typisk opdateres BAF (Bunker Adjustment Factor) og CAF (Currency Adjustment Factor) en gang om måneden. Fastlane følger nøje udviklingen af markedet, så vi kan tilbyde gode præcise containerrater til vores kunder. Optimale søfragtsrater er vigtige, men det er lige så vigtigt at have styr på transporterne m.h.t.
            </p>

            <ul className="space-y-1.5 text-sm sm:text-base text-slate-700 bg-slate-50 p-5 rounded-xl border border-slate-200">
              <li className="flex items-center gap-2"><i className="fa-solid fa-check text-sky-600" aria-hidden="true" /> afsendelse</li>
              <li className="flex items-center gap-2"><i className="fa-solid fa-check text-sky-600" aria-hidden="true" /> ankomst</li>
              <li className="flex items-center gap-2"><i className="fa-solid fa-check text-sky-600" aria-hidden="true" /> korrekt routing i.f.h.t. kundens behov</li>
              <li className="flex items-center gap-2"><i className="fa-solid fa-check text-sky-600" aria-hidden="true" /> rettidig præsentation af dokumenter</li>
              <li className="flex items-center gap-2"><i className="fa-solid fa-check text-sky-600" aria-hidden="true" /> rettidig fortolding</li>
              <li className="flex items-center gap-2"><i className="fa-solid fa-check text-sky-600" aria-hidden="true" /> rettidig afhentning af gods/container</li>
              <li className="flex items-center gap-2"><i className="fa-solid fa-check text-sky-600" aria-hidden="true" /> rettidig tilbagelevering af container rettidigt</li>
            </ul>

            <p>
              Afhentes containeren ikke til tiden i haven skal der betales demurage til rederiet og levers containeren ikke tilbage til depotet indenfor rederiets tidsfrist skal der betales detention. Blot for at nævne nogle eksempler. Der kan spares mange penge ved præcis udførsel og opfølgning. Processen er afhængig af af afsender, sælger, modtager og køber spiller med.
            </p>
            <p className="font-semibold text-[#0f2b48]">
              Kort sagt. De bedste containerrater opnås ved rettidig omhu, know how og godt købmandskab. Vi varertager kundens behov og superviserer processen, så der blive tale om ægte outsourcing.
            </p>
            <p>
              Typisk sendes godset containere, såsom 20 ft DC (Dry Container) eller 40 ft DC / HC (High Cube). Søfragt i eller på special udstyr (se{' '}
              <a href="https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/3-3-8-rev-00-instruktion-containertyper-0.pdf" target="_blank" rel="noopener noreferrer" className="text-sky-700 underline font-semibold">
                Instruktion Containertyper
              </a>) kan også arrrangeres.
            </p>
            <p>
              Containerfragt består ikke kun af søfragt, men også af tilslutningstransporter i afsender landet og modtager landet. Hvilken dele af transporten sælger og køber skal betale for / har ansvar for er til en vis grad beskrevet i Incoterms 2020 (se{' '}
              <a href="https://assets.auxodev.dk/assets/2e6d0d1c-821d-400c-80aa-275c6c0c86cc/incoterms-2020-fastlane-5.pdf" target="_blank" rel="noopener noreferrer" className="text-sky-700 underline font-semibold">
                Incoterms 2020
              </a>).
            </p>
          </div>

          {/* Havnebyer USA & Canada */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-6 bg-slate-50 rounded-2xl border border-slate-200">
              <h3 className="text-lg font-bold text-[#0f2b48] mb-3">USA Havnebyer:</h3>
              <p className="text-sm text-slate-700 leading-relaxed font-medium">
                New York, Miami, Los Angeles, Charleston, Houston, Tampa, Jacksonville, Norfolk, Boston, Chicago og Seattle.
              </p>
            </div>
            <div className="p-6 bg-slate-50 rounded-2xl border border-slate-200">
              <h3 className="text-lg font-bold text-[#0f2b48] mb-3">Canada Havnebyer:</h3>
              <p className="text-sm text-slate-700 leading-relaxed font-medium">
                Montreal, Québec, Toronto og Vancouver.
              </p>
            </div>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row gap-3 sm:gap-4 sm:items-center sm:justify-between border-t border-slate-200">
            <span className="text-sm text-slate-600">Søger du en fragtrate til eller fra USA / Canada?</span>
            <Link
              to="/fragtrater"
              className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#b25d19] text-white text-sm font-semibold hover:bg-[#974d12] text-center"
            >
              Forespørg fragtrate
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
